import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

type Props = {
  close: boolean;
  handleClose: () => void;
  discountValue: string;
  courseDetail: any;
};

const PromoMobileView: FC<Props> = ({
  close,
  handleClose,
  discountValue,
  courseDetail,
}) => {
let navigate = useNavigate();
  return (
    
    <div>
      <Modal className="cursor-pointer" show={close} centered={true} size="sm">
   
  <Modal.Body
    
    className="bg-[#0f5a0d] p-0"
  >
    <div className="pb-10 pr-8">
      <div className="flex">
        <div></div>
        <FontAwesomeIcon
          onClick={handleClose}
          className="bg-[#FFFFFF] cursor-pointer h-[15px] w-[15px] rounded-full ml-auto mt-3"
          icon={faXmark}
          style={{ color: "#5c6bc0" }}
        />
      </div>

      <div  onClick={() => navigate(`/coursedetails/${courseDetail?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}>
        <ul className="flex flex-col gap-10 items-center justify-center text-nowrap mx-10">
          <li className="flex flex-col items-center">
            <div className="text-center h-[60px] w-[60px] rounded-full ml-1 bg-[#FFFFFF] flex flex-col items-center justify-center">
              <span className="text-[#0f5a0d] text-[26px] font-[700] mt-[10px]">
                {discountValue}%
              </span>
              <span className="text-[#0f5a0d] text-[12px] font-[400] -mt-3">
                OFF
              </span>
            </div>
            <div className="mt-[10px] text-center">
              <div className="text-[25px] text-[#FFFFFF]">SPECIAL</div>
              <div className="text-[32px] text-[#FFFFFF] -mt-[10px]">OFFER</div>
            </div>
          </li>
          <li className="flex flex-col items-center">
            <h1 className="text-[24px] text-[#FFFFFF]">Learn & Master</h1>
            <h1 className="text-center text-wrap text-[32px] text-[#FFFFFF] mt-[10px]">
              {courseDetail?.CourseName}
            </h1>
          </li>

          <li className="bg-[#FFFFFF] rounded-[10px] py-1 px-4">
            <button
              onClick={() => navigate(`/coursedetails/${courseDetail?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}
              className="border-none font-[700] hover:scale-[1.1] text-[28px] text-nowrap text-[#367E3E]"
            >
              Grab this offer
            </button>
          </li>
        </ul>
      </div>
    </div>
  </Modal.Body>
</Modal>
    </div>
  );
};

export default PromoMobileView;